var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParliament = function SvgParliament(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.04 136.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".parliament_svg__cls-1{fill:#dde3f3}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parliament_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "parliament_svg__Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m135.38 131.39-14.17-17a2.82 2.82 0 0 0-2.18-1H17a2.81 2.81 0 0 0-2.17 1l-14.17 17A2.84 2.84 0 0 0 2.83 136h130.38a2.83 2.83 0 0 0 2.17-4.65Z",
    className: "parliament_svg__cls-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.67,
    height: 48.18,
    x: 17,
    y: 59.52,
    className: "parliament_svg__cls-1",
    rx: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.67,
    height: 48.18,
    x: 56.68,
    y: 59.52,
    className: "parliament_svg__cls-1",
    rx: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.67,
    height: 48.18,
    x: 96.36,
    y: 59.52,
    className: "parliament_svg__cls-1",
    rx: 2.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81 52.59a2.86 2.86 0 0 0 2.36 1.26h107.7a2.86 2.86 0 0 0 2.36-1.26l5.67-8.51a2.83 2.83 0 0 0-2.36-4.4H8.5a2.84 2.84 0 0 0-2.36 4.4ZM8.5 34h119a2.84 2.84 0 0 0 1.22-5.4L69.24.27a2.89 2.89 0 0 0-2.44 0L7.28 28.61A2.84 2.84 0 0 0 8.5 34",
    className: "parliament_svg__cls-1"
  })))));
};
export default SvgParliament;